import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { push } from "react-router-redux";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
  translate,
  crudGetMany as crudGetManyAction,
  showNotification,
} from "react-admin";
import compose from "recompose/compose";
import withStyles from "@material-ui/core/styles/withStyles";
import { flatten, map, prop, path, sum, isNil, filter, propEq } from "ramda";
import moment from "moment";
import styled from "styled-components";
import dataProviderFactory from "../dataProvider";
import { UPDATE, Button } from "react-admin";
import ForwardIcon from "@material-ui/icons/Forward";
import { DATEFORMAT } from "../date-config";
import {
  applyLowSeasonDiscountFor,
  buildRentalPromoSnapshot,
} from "../util/rentalPromo";

const StyledTableCell = styled(TableCell)`
  white-space: nowrap;
`;

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  boldCell: { fontWeight: "bold" },
};

class RefundButton extends Component {
  state = {
    visible: true,
  };
  handleClick = async () => {
    const { record, rentalId, reloadData } = this.props;
    const dataProvider = await dataProviderFactory("rest");
    const bodyRequest = { id: record.id, data: { status: 2 } };

    this.setState({ visible: false });

    dataProvider(UPDATE, "charges", bodyRequest)
      .then((response) => {
        //console.log(response);
        reloadData(rentalId);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  render() {
    // if (this.state.visible) {
    //   return (
    //     <Button label="Refund" onClick={this.handleClick}>
    //       <ForwardIcon />
    //     </Button>
    //   );
    // }
    return "";
  }
}

class ChargesGrid extends Component {

  duration = (date1, time1, date2, time2) => {
    const days = moment(date2).diff(date1, "days");
    if (time1 === "10:00:00" && time2 === "18:00:00") {
      return days + 1;
    } else if (time1 === "18:00:00" && time2 === "10:00:00") {
      return days - 1;
    }
    return days || 0;
  };
  getVehicleModelPrices(modelPrices, days) {
    let priceForDays;
    modelPrices.map(price => {
      if (price.days_interval_1 <= days && price.days_interval_2 >= days) {
        priceForDays = price;
      }
    });

    return prop("price", priceForDays) || 0;
  }
  render() {
    const { classes, rental, charges, push, reloadData, estados } = this.props;
    let { record } = this.props;
    if (!isNil(rental)) {
      record = rental;
    }
    if (!record) return null;

    // const extraChargesValues =
    //   sum(map(prop("value"), filter(propEq("extra_charge", true), charges))) ||
    //   0;

    // const extraChargesReunded =
    //   sum(
    //     map(
    //       prop("refunded_value"),
    //       filter(propEq("extra_charge", true), charges)
    //     )
    //   ) || 0;

    // const extraCharges = extraChargesValues - extraChargesReunded;

    const extraCharges = 0;

    const totalRefunded = sum(
      map(
        prop("refunded_value"),
        filter(
          propEq("status", true),
          filter(propEq("to_refund", true), charges)
        )
      )
    );

    const totalPayed =
      sum(
        map(
          prop("value"),
          filter(
            propEq("status", true),
            charges
            // filter(propEq("to_refund", false), charges)
          )
        )
      ) + (record.type === 1 ? extraCharges : 0) - totalRefunded;
    const booking = record.booking;
    const rewardsBokking = (booking.rewards == null) ? 0 : booking.rewards;
    const discount = (record.discount == null) ? 0 : record.discount;
    const paidRounded = parseFloat(Number(totalPayed).toFixed(2));
    // payment.value es el total neto contractual (ya con rewards). No restar rewards otra vez
    // sobre rental_price neto (36207: 555−15−570 = −30).
    const paymentNet = path(["payments", 0, "value"], record);
    let netOwed;
    if (paymentNet != null && Number(paymentNet) > 0) {
      netOwed = Number(paymentNet);
    } else if (rewardsBokking > 0 && paidRounded + 0.01 >= Number(record.rental_price)) {
      netOwed = Number(record.rental_price);
    } else {
      netOwed = Number(record.rental_price) - Number(discount) - Number(rewardsBokking);
    }
    let valueRemaining = parseFloat((netOwed - paidRounded).toFixed(2));

    if (Math.abs(paidRounded - Number(record.rental_price)) < 0.02) {
      valueRemaining = 0;
    } else if (Math.abs(valueRemaining - Number(totalRefunded || 0)) < 0.02) {
      valueRemaining = 0;
    }
    
    //console.log(estados)
    let rentalDays = 0
    let extrasDays = 0
    let lowSeasonPct = 0
    let modelPrices1 = 0
    let locationFees = 0
    let gpsPrice = 0
    let vipInsurancePrice = 0
    let vip = 0
    if(estados.date_1 != undefined &&  record.type !== 1){
      const promo = buildRentalPromoSnapshot({
        date_1: estados.date_1,
        time_1: estados.time_1,
        date_2: estados.date_2,
        time_2: estados.time_2,
        from_agency: estados.from_agency != null
          ? estados.from_agency
          : (record && record.from_agency),
      });
      rentalDays = promo.moto_days;
      extrasDays = promo.extras_days;
      lowSeasonPct = promo.low_season_pct;
      modelPrices1 = this.getVehicleModelPrices(estados.modelPrices1, rentalDays);
      locationFees =  estados.locationFees[0] != undefined ? estados.locationFees[0].price : 0 
      gpsPrice =  estados.gpsPrices[0] != undefined ? estados.gpsPrices[0].price : 0 
      vipInsurancePrice =  estados.insurancePrices != undefined ? estados.insurancePrices : 0
      vip = vipInsurancePrice.find(element => element.price_item_type = 1);
    } 
 
    if(!estados.r_gps){
      gpsPrice = 0
    }
    if(!estados.r_insurance){
      vip = 0
    }
    else{
      vip = vip.price
    }

    const promoSnap = { low_season_pct: lowSeasonPct, low_season_apply_moto: true, low_season_apply_gps: true };
    const motoTotal = applyLowSeasonDiscountFor(
      modelPrices1 * rentalDays,
      promoSnap,
      "moto"
    );
    const gpsTotal = applyLowSeasonDiscountFor(
      gpsPrice * extrasDays,
      promoSnap,
      "gps"
    );
    const vipTotal = applyLowSeasonDiscountFor(vip * extrasDays, promoSnap, "vip");
    const oneWayTotal = applyLowSeasonDiscountFor(locationFees, promoSnap, "one_way");
    let rentalTotal1 =
    motoTotal +
    gpsTotal +
    vipTotal +
    oneWayTotal - estados.rewards;  

    // console.log(rentalTotal1)
    let rentalsType = ''
    if(record.type === 1)
      {rentalsType = 'Tour Total'}
    else if(record.type === 2)
      {rentalsType = 'Total Rental'}
    return (
      <Paper className={classes.container}>
        <h3>Payments</h3>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.rightAlignedCell}>Value</TableCell>
              <TableCell className={classes.rightAlignedCell}>Date</TableCell>
              <StyledTableCell className={classes.rightAlignedCell}>
                Type / Status
              </StyledTableCell>
              {/* <TableCell className={classes.rightAlignedCell}>Type</TableCell> */}
              {/* <TableCell className={classes.rightAlignedCell}>
                Comments
              </TableCell> */}
              <TableCell className={classes.leftAlignedCell}>
                Refunded
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {charges.map((item) => (
              <TableRow key={item.id}>
                <TableCell className={classes.rightAlignedCell}>
                  {(item.value).toLocaleString(
                    undefined,
                    {
                      style: "currency",
                      currency: "EUR",
                    }
                  )}
                </TableCell>
                <StyledTableCell className={classes.rightAlignedCell}>
                  {moment.utc(item.date).format(DATEFORMAT)}
                </StyledTableCell>
                <StyledTableCell className={classes.rightAlignedCell}>
                  {item.charge_type === 1 ? "Stripe" : "Other"}/
                  {item.status ? "Paid" : "Not Paid"}
                </StyledTableCell>
                {/* <TableCell className={classes.rightAlignedCell}>
                </TableCell> */}
                {/* <TableCell className={classes.rightAlignedCell}>
                  {item.comments}
                </TableCell> */}
                <StyledTableCell className={classes.rightAlignedCell}>
                  {/* {item.to_refund ? "Yes" : "No"} */}
                  {item.refunded_value.toLocaleString(undefined, {
                    style: "currency",
                    currency: "EUR",
                  })}
                  {/* {item.charge_type === 1 && item.status && ( */}
                  {item.value > item.refunded_value && item.status && (
                    <RefundButton
                      record={item}
                      rentalType={rental.type}
                      rentalId={rental.id}
                      push={push}
                      reloadData={reloadData}
                    />
                  )}
                </StyledTableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={2} />
              <StyledTableCell>Value Remaining</StyledTableCell>
              <StyledTableCell
                className={classnames(
                  classes.boldCell,
                  classes.rightAlignedCell
                )}
              >
                {valueRemaining.toLocaleString(undefined, {
                  style: "currency",
                  currency: "EUR",
                })}
              </StyledTableCell>
            </TableRow>  
            <TableRow>
              <TableCell colSpan={2} />
              <StyledTableCell>Total Rewards</StyledTableCell>
              <TableCell
                className={classnames(
                  classes.boldCell,
                  classes.rightAlignedCell
                )}
              >
                {rewardsBokking.toLocaleString(undefined, {
                  style: "currency",
                  currency: "EUR",
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2} />
              <StyledTableCell>Total discount</StyledTableCell>
              <TableCell
                className={classnames(
                  classes.boldCell,
                  classes.rightAlignedCell
                )}
              >
                {discount.toLocaleString(undefined, {
                  style: "currency",
                  currency: "EUR",
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2} />
              <StyledTableCell>Total Paid</StyledTableCell>
              <TableCell
                className={classnames(
                  classes.boldCell,
                  classes.rightAlignedCell
                )}
              >
                {totalPayed.toLocaleString(undefined, {
                  style: "currency",
                  currency: "EUR",
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2} />
              <StyledTableCell>Total Refunded</StyledTableCell>
              <TableCell
                className={classnames(
                  classes.boldCell,
                  classes.rightAlignedCell
                )}
              >
                {totalRefunded.toLocaleString(undefined, {
                  style: "currency",
                  currency: "EUR",
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2} />
              <StyledTableCell>{rentalsType}</StyledTableCell>
              <TableCell
                className={classnames(
                  classes.boldCell,
                  classes.rightAlignedCell
                )}
              >
                {(record.rental_price).toLocaleString(undefined, {
                  style: "currency",
                  currency: "EUR",
                })}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

const mapStateToProps = (state, props) => {
  if (isNil(props.record)) {
    return {};
  }
  const {
    record: { payments },
  } = props;

  const charges = flatten(map(prop("charges"), payments));

  return {
    charges,
  };
};

const enhance = compose(
  translate,
  withStyles(styles),
  connect(mapStateToProps, {
    showNotification,
    push,
    crudGetMany: crudGetManyAction,
  })
);

export default enhance(ChargesGrid);



// WEBPACK FOOTER //
// ./src/components/listCharges.js